import TableRow from '../../../../table/TableRow'

function UserTableRow() {
    this.constructor = UserTableRow;
    this.permissionsCell = null
    this.nameCell = null
    this.teamScopeCell = null
    this.manageScopeCell = null
}

UserTableRow.prototype = new TableRow();

UserTableRow.prototype.init = function(userListUserInfo) {
    TableRow.call(this);
    this.userListUserInfo = userListUserInfo;
    return this;
};

UserTableRow.prototype.getUserListUserInfo = function() {
    return this.userListUserInfo;
};

// TODO: Need to introduce Column class defining:
// - column number
// - Cell renderer (probably more than one if several row types are possible)
// - Cell factory  (probably more than one if several row types are possible)
UserTableRow.prototype.writeCellsContent = function() {
    var cells = this.getCells();
    for (var i = 0; i < cells.length; i++)
        cells[i].writeContent();
};

UserTableRow.prototype.addTeamScopeCellObj = function(teamScopeCell) {
    TableRow.prototype.addCellObj.call(this, teamScopeCell)
    this.teamScopeCell = teamScopeCell
}

UserTableRow.prototype.addManageScopeCellObj = function(manageScopeCell) {
    TableRow.prototype.addCellObj.call(this, manageScopeCell)
    this.manageScopeCell = manageScopeCell
}

UserTableRow.prototype.addPermissionsCellObj = function(permissionsCell) {
    TableRow.prototype.addCellObj.call(this, permissionsCell)
    this.permissionsCell = permissionsCell
}

UserTableRow.prototype.getPermissionsCell = function() {
    return this.permissionsCell
}

UserTableRow.prototype.getTeamScopeCell = function() {
    return this.teamScopeCell
}

UserTableRow.prototype.getManageScopeCell = function() {
    return this.manageScopeCell
}

UserTableRow.prototype.addNameCellObj = function(nameCell) {
    TableRow.prototype.addCellObj.call(this, nameCell)
    this.nameCell = nameCell
}

UserTableRow.prototype.getNameCell = function() {
    return this.nameCell
}

export default UserTableRow




// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/UserTableRow.js